export var ChainId;
(function (ChainId) {
    ChainId[ChainId["MerlinTestnet"] = 686868] = "MerlinTestnet";
    ChainId[ChainId["EthereumHolesky"] = 17000] = "EthereumHolesky";
    ChainId[ChainId["Sepolia"] = 11155111] = "Sepolia";
    // BobSepolia = 808813,
    ChainId[ChainId["BaseSepolia"] = 84532] = "BaseSepolia";
    ChainId[ChainId["ModeSepolia"] = 919] = "ModeSepolia";
    ChainId[ChainId["ArbitrumSepolia"] = 421614] = "ArbitrumSepolia";
    ChainId[ChainId["CoreTestnet2"] = 1114] = "CoreTestnet2";
})(ChainId || (ChainId = {}));
